export default "__VITE_ASSET__DakkyMqg__"